import { render, staticRenderFns } from "./Consideracion.vue?vue&type=template&id=7c508424"
import script from "./Consideracion.vue?vue&type=script&lang=js"
export * from "./Consideracion.vue?vue&type=script&lang=js"
import style0 from "./Consideracion.vue?vue&type=style&index=0&id=7c508424&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports